{
"receive.heading": "استلم الشحنات",
"receive.description": "تعرض هذه الصفحة حالة ودورة وعدد الحاويات والحزم في عملية الاستلام",
"receive.filter.title": "العنوان",
"receive.filter.cycle": "الدورة",
"package.cpt": "CPT",
"receive.overall_status": "الحالة العامة",
"receive.packages": "الشحنات",
"CPT.": "CPT",
"CPT.cpt": "CPT",
"CPT.induct_by": "استقراء بواسطة",
"CPT.stow_by": "ستو باي",
"status.current_planned": "المخطط الحالي",
"status.planned_inducted": "الفعلي المحرض الحالي",
"status.unplanned_inducted": "أخرى / فعلية غير مخطط لها",
"receive.predicted_dispatch":"الشحنات المتوقعة (LMCP)",
"receive.total_manifested": "إجمالي الشحنات المنشأة",
"receive.container_planned_volume": "حجم الحاوية المخطط له",
"receive.current_cycle_planned": "الدورة الحالية المخطط لها",
"receive.current_cycle_actual": "الدورة الحالية الفعلية",
"receive.other_cycles": "الدورة الأخرى/غير المخطط لها التي وصلت",
"receive.current_planned": "المخطط الحالي",
"receive.current_actual": "الفعلي الحالي",
"receive.other": "وصلت أخرى / غير مخطط لها الفعلي",
"receive.total": "إجمالي الشحنات التي وصلت",
"receive.current_status": "الحالة في الوقت الحالي",
"receive.manifested": " المنشأة",
"receive.manifested.unplanned": "المنشأة غير المخطط لها",
"receive.in_transit": "في مرحلة النقل",
"receive.in_transit.unplanned": "غير المخطط لها في مرحلة النقل",
"receive.arrived": "التي وصلت",
"receive.arrived.unplanned": "التي وصلت دون تخطيط",
"receive.marked_for_reprocess": "ستتم إعادة معالجتها",
"receive.marked_for_reprocess.unplanned": "غير مخطط لها وستتم إعادة معالجتها",
"receive.inducted": "الممسوحة ضوئياً",
"receive.stow_buffered": "ستو مخزنة",
"receive.stowed": "المرتبة على الرفوف",
"receive.sidelined": "ستتم معالجتها بشكل منفصل",
"receive.group_by": "مجموعة من",
"linehaul.linehauls" : "خط الرحلات",
"linehaul.status": "الحالة",
"linehaul.arrival": "الوصول",
"linehaul.details": "التفاصيل",
"linehaul.vrid": "VRID",
"linehaul.origin": "المنشأ/المصدر",
"linehaul.location": "الموقع",
"linehaul.planned": "المخطط لها",
"linehaul.actual": "الفعلية",
"linehaul.volume": "الحجم",
"linehaul.FMC": "وحدة التحكم في إدارة الشحن FMC",
"linehaul.unloadSequence": "تسلسل التفريغ",
"linehaul.inyard": "في منطقة الاصطفاف",
"linehaul.arrived": "التي وصلت",
"linehaul.incoming": "الواردة",
"linehaul_detail.receive": "استلم الشحنات",
"linehaul_detail.linehaul_details": "تفاصيل خط الرحلات",
"linehaul_detail.linehaul": "خط الرحلة ",
"linehaul_detail.from": "من",
"linehaul_detail.departed": "المغادرة",
"linehaul_detail.arrived": "التي وصلت",
"linehaul_detail.options": "الخيارات",
"linehaul_detail.id": "الرقم التعريفي",
"linehaul_detail.type": "النوع",
"linehaul_detail.pending_induct": "بانتظار المسح الضوئي",
"linehaul_detail.total": "الإجمالي ",
"linehaul_filter.packagesize": "حجم الشحنة",
"linehaul_filter.ead": "محطة التاريخ المتوقع للوصول",
"linehaul_filter.cycle": "الدورة",
"linehaul_filter.cluster": "مجموعة الشحنات",
"linehaul_filter.otherattributes": "خصائص أخرى",
"linehaul_filter.unplanned": "غير مخطط له",
"linehaul_filter.sideline": "تنحية",
"linehaul_filter.commercial": "تجاري",
"linehaul_filter.cosmos": "Cosmos",
"linehaul_filter.clear_all": "مسح الكل",
"receivergroup.none": "لا أحد",
"receivergroup.package_size": "حجم الطرد",
"receivergroup.station_ead": "EAD للمحطة",
"receivergroup.cluster": "Cluster",
"receivergroup.cycle": "الدورة",
"status.current_cycle_planned": "الحجم المخطط للدورة الحالية",
"status.planned_inducted_cycle": "الحجم الفعلي المدخل للدورة الحالية",
"status.unplanned_inducted_cycle": "الحجم الفعلي المدخل للدورة الحالية",
"status.total_inducted": "إجمالي الحجم الفعلي المدخل",
"induct.heading": "المسح الضوئي",
"induct.description": "تعرض هذه الصفحة حالة ودورة وعدد الحاويات والحزم في عملية الحث",
"induct.induct": "المسح الضوئي",
"induct.induct_area": "مناطق المسح الضوئي",
"induct.active_associate": "الموظفون المتاحون",
"induct.induct_rate": "معدل المسح الضوئي",
"induct.total_inducted": "إجمالي الشحنات الممسوحة ضوئياً",
"induct.container": "الحاوية",
"induct.container_id": "الرقم التعريفي",
"induct.type": "النوع",
"induct.pending_induct": "بانتظار المسح الضوئي",
"induct.total": " الإجمالي",
"induct.aslInductArea": "ASL Induct Area",
"induct.max_induct_rate": "Max Induct rate",
"induct.station_percentage": "% of station",
"induct.successful_percentage": "% Successful",
"induct.kickout": "Kickout",
"induct.noread": "NoRead",
"induct.timeout": "Timeout",
"induct.failed_verification": "Failed Verification",
"induct.sidelined": "Sidelined",
"induct.cycle": "الدورة",
"associate.heading": "المسح الضوئي المنتسبين",
"associate.description": "تعرض هذه الصفحة بيانات أداء المنتسبين وموقع العمل الحالي.",
"associate.option": "الخيارات",
"associate.active": "فعّال",
"associate.associates": "الموظفون",
"associate.associate": "الموظف",
"associate.pph": "PPH",
"associate.hours": "الساعات",
"associate.total_packages": "إجمالي الشحنات",
"associate.yes": "نعم",
"associate.no": "لا",
"associate.location": "الموقع",
"associate.inactive_period": "الفترة غير الفعالة",
"package.package_summary": "ملخص الشحنة",
"package.tracking_id": "رقم التتبع",
"package.last_scan_date_time": "آخر مسح ضوئي",
"package.minutes_in_state": "مدة نفس الحالة",
"package.package_state": "الحالة",
"package.package_reason": "السبب",
"package.location": "الموقع",
"package.cycle": "الدورة",
"package.sort_zone": "منطقة الفرز",
"package.cluster": "مجموعة الطرود",
"package.EAD": "محطة التاريخ المتوقع للوصول",
"package.size": "الحجم",
"package.station_code": "الوجهة",
"package.package_list": "قائمة الشحنة",
"package.download": "تحميل",
"induct.error": "حدثت بعض الأخطاء",
"tooltip.current_arrived": "الشحنات المخططة التي وصلت أو تم إدخالها أو إعادة إدخالها قيد المراجعة",
"tooltip.other_unplanned_arrived_actual": "الشحنات الأخرى التي وصلت المحطة",
"tooltip.total_arrived_actual": "وصلت الدورة الحالية بالإضافة إلى أخرى / وصلت غير مخطط لها فعليًا",
"tooltip.predicated_lmcp": "الشحنات المتوقعة LMCP",
  "tooltip.current_planned": "مخطط الفرز (RTW) للشحنات التي تم إنشاؤها",
  "tooltip.planned_inducted": "الدورة الحالية التي وصلت",
  "tooltip.unplanned_inducted": "الدورة الأخرى غير المخطط لها التي وصلت",
  "tooltip.manifested": "الشحنات المخطط لها في هذا الوقت والتي تم عرضها على شاحنة تم التخطيط لها لمحطة التسليم",
  "tooltip.unplanned_manifested": "الشحنات التي لم يتم التخطيط لها في هذا الوقت والتي تم إظهارها لشاحنة تم التخطيط لها لمحطة التسليم",
  "tooltip.in_transit": "الشحنات المخطط لها في هذا الوقت والتي تكون في شاحنة في طريقها إلى محطة التسليم",
  "tooltip.unplanned_in_transit": "الشحنات التي لم يتم التخطيط لها في هذا الوقت والتي تكون في شاحنة في طريقها إلى محطة التسليم في شاحنة في طريقها إلى محطة التسليم",
  "tooltip.arrived": "الشحنات المخططة لهذا الوقت والتي وصلت إلى محطة التسليم",
  "tooltip.unplanned_arrived": "الشحنات غير المخطط لها لهذا الوقت والتي وصلت إلى محطة التسليم",
  "tooltip.marked_for_reprocess": "الشحنات المخططة لهذا الوقت والتي تم حلها عبر Fixit",
  "tooltip.unplanned_marked_for_reprocess": "الشحنات التي لم يتم التخطيط لها في هذا الوقت والتي تم حلها عبر Fixit",
  "tooltip.inducted": "الشحنات الموجودة حاليًا في حالة الحزمة هذه وتم إدخالها بنجاح خلال هذا الوقت",
  "tooltip.stowed": "الشحنات الموجودة حاليًا في حالة الحزمة هذه وتم تخزينها بنجاح خلال هذا الوقت",
  "tooltip.sidelined": "الشحنات الموجودة حاليًا في حالة الطرد التي تم احتجازها (جانبيًا) والتي تم تهميشها في الحث خلال هذا الوقت",
  "tooltip.current_cycle_planned": "مخطط الفرز (RTW) للشحنات التي تم إنشاؤها",
  "tooltip.planned_cycle_inducted": "الدورة الحالية التي وصلت",
  "tooltip.unplanned_cycle_inducted": "الدورة الأخرى غير المخطط لها التي وصلت",
  "tooltip.total_inducted_cycle": "الدورة الحالية التي وصلت والدورة الأخرى/غير المخطط لها التي وصلت",
  "tooltip.stowbuffered_cycle": "الشحنات الموجودة حاليًا في حالة الحزمة هذه والتي تم تخزينها مؤقتًا بنجاح خلال هذه الدورة",
  "tooltip.manifested_cycle": "الشحنات المخططة لهذه الدورة والتي تحتوي على بيان جمركي مرفق ومن المقرر أن تذهب إلى محطة التوصيل",
  "tooltip.unplanned_manifested_cycle": "الشحنات غير المخططة لهذه الدورة والتي تحتوي على بيان جمركي مرفق ومن المقرر أن تذهب إلى محطة التوصيل",
  "tooltip.in_transit_cycle": "الشحنات المخططة لهذه الدورة والتي تكون في شاحنة في مرحلة النقل إلى محطة التوصيل",
  "tooltip.unplanned_in_transit_cycle": "الشحنات غير المخططة لهذه الدورة والتي تكون في شاحنة في مرحلة النقل إلى محطة التوصيل",
  "tooltip.arrived_cycle": "الشحنات المخططة لهذه الدورة والتي وصلت إلى محطة التوصيل",
  "tooltip.unplanned_arrived_cycle": "الشحنات غير المخططة لهذه الدورة والتي وصلت إلى محطة التوصيل",
  "tooltip.marked_for_reprocess_cycle": "الشحنات التي تم وضع علامة عليها لإعادة المعالجة عبر فيكسيت (Fixit)",
  "tooltip.unplanned_marked_for_reprocess_cycle": "الشحنات غير المخططة والتي تم وضع علامة عليها لإعادة المعالجة عبر فيكسيت (Fixit)",
  "tooltip.inducted_cycle": "الشحنات الموجودة حالياً في حالة الطرد هذه والتي تم مسحها ضوئياً بنجاح أثناء هذه الدورة",
  "tooltip.stowed_cycle": "الشحنات الموجودة حالياً في حالة الطرد هذه والتي تم ترتيبها على الرف بنجاح أثناء هذه الدورة",
  "tooltip.sidelined_cycle": "الشحنات التي ستتم معالجتها بشكل منفصل أثناء المسح الضوئي خلال هذه الدورة",
"tooltip.current_cycle_arrived": "الدورة الحالية التي وصلت",
"tooltip.other_unplanned_cycle_arrived_actual": "الدورة الأخرى غير المخطط لها التي وصلت",
"tooltip.total_arrived_actual_cycle": "الدورة الحالية التي وصلت والدورة الأخرى/غير المخطط لها التي وصلت",
  "tooltip.max_induct_rate": "Maximum expected induct rate for the ASL machine.",
  "tooltip.induct_rate": "Average number of packages inducted per hour.",
  "tooltip.non_conveyable_description": "NC: Packages that exceed 42'' in a single dimension. \n FCLM might have different dimension criteria for NC",
  "tooltip.total_inducted": "Total number of packages inducted in the current shift.",
  "tooltip.station_percentage": "Percentage of total station volume that was inducted using the ASL machine.",
  "tooltip.successful_percentage": "Percentage of packages that were successfully scanned by the ASL machine.",
  "tooltip.kickout": "Number of packages that were kicked-out during ASL induct.",
  "tooltip.noread": "Number of ASL processed packages where a valid barcode was not read by the entry camera.",
  "tooltip.timeout": "Number of ASL processed package scans which did not receive induct response within the SLA.",
  "tooltip.failed_verification": "Number of ASL processed packages which were not verified by the exit camera.",
  "induct_management.induct_setup": "Induct Setup",
  "induct_management.select_cycle": "Select Cycle",
  "induct_management.current_sort_cycle": "Current Sort Cycle",
  "induct_management.current_cycle_state": "Current Cycle State",
  "induct_management.current_force_induct_status": "Current Force Induct Status",
  "induct_management.enable_force_induct": "Enable Force Induct",
  "induct_management.sort_cycle": "Sort Cycle",
  "induct_management.force_induct_sort_cycle": "Force induct all received packages in current sort cycle",
  "induct_management.start_sort_cycle": "Start Induct",
  "induct_management.container_plan_failure" : "There is an error fetching Container Plan. Please try again Later",
  "induct_management.mapped_cycles_failure" : "There is an error fetching Active Cycles. Please try again Later",
  "induct_management.set_node_operational_failure" : "There is an error saving the Induct Cycle. Please Try again Later",
  "induct_management.get_node_operational_failure" : "There is an error getting the current Sort Cycle Information. Please Try again Later",
  "induct_management.non_mco_station" : "This page is not enabled yet for your station. If your station supports multi cycle operations, stay tuned for more updates :-)",
  "induct_management.bad_request" : "Please select correct cycle from the dropdown",
  "induct_management.set_node_induct_process_details_success" : "Induct Cycle has been started successfully",
  "induct_management.no_active_container_plans_available" : "There are no active container plans configured for this station, Please try again later",
  "induct_management.pick_started_for_the_current_cycle" : "Pick has been started for the current cycle, so induct is blocked on ",
  "induct_management.start_induct" : ". Please change to correct cycle and start the induct process.",
  "common.data_last_updated": "آخر تحديث للبيانات",
  "inductmanagement.heading": "إدارة دورة المسح الضوئي",
  "inductmanagement.description": "تتيح لك هذه الصفحة تغيير إعدادات دورة المسح",
  "inductmanagement.manage_cycle": "إدارة الدورات",
  "inductmanagement.force_induct": "مسح القوة",
  "inductmanagement.active_until": "نشط حتى",
  "inductmanagement.noCycles": "إدارة الدورات",
  "inductmanagement.disableCycle": "تعطيل الدورة",
  "inductmanagement.enableCycle": "تمكين الدورة",
  "inductmanagement.enterCycle": "أدخل الدورة",
  "inductmanagement.enterStationCode": "أدخل رمز المحطة",
  "inductmanagement.noStations": "لا توجد محطات متاحة",
  "inductmanagement.selectStatus": "حدد الحالة",
  "inductmanagement.enableForceInduct": "تمكين مسح القوة",
  "inductmanagement.disableForceInduct": "تعطيل فحص القوة",
  "inductmanagement.activateSortToRouteError": "لا يمكن تنشيط دورة نوع SORT_TO_ROUTE أخرى. {cycle} نشطة بالفعل",
  "inductmanagement.activateCycleError": "واجه خطأ أثناء تنشيط الدورة: {cycle}",
  "inductmanagement.deactivateCycleError": "واجه خطأ أثناء إلغاء تنشيط الدورة: {cycle}",
  "inductmanagement.unselectedWarning": "الرجاء تحديد عقدة ودورة قبل النقر فوق تنشيط",
  "inductmanagement.setForceError": "واجه خطأ أثناء تحديث فحص القوة للدورة: {cycleName}",
  "inductmanagement.submit": "يُقدِّم",
  "inductconfig.noActiveLanes": "جميع المسارات إما غير نشطة أو مسارات احتجاز، لا توجد مسارات متبقية للبالتات أو العربات.",
  "inductconfig.noCartLanes": "جميع المسارات إما غير نشطة أو مسارات احتجاز أو مسارات بالتات. لا توجد مسارات متبقية للعربات.",
  "inductconfig.noBeltsConfigured": "لا توجد أحزمة إدخال مكوّنة. يرجى إضافة حزام واحد على الأقل.",
  "inductconfig.holdLaneWarning": "لم يتم تكوين مسارات احتجاز. لا يمكن احتجاز الحاويات خلال هذه الدورة. هل تريد المتابعة؟",
  "inductconfig.singleBeltWarning": "تم تكوين حزام نشط واحد فقط. إذا تعطل هذا الحزام، لا يمكن إدخال أي طرود. هل تريد المتابعة؟",
  "inductconfig.inactiveHoldOverlap": "المسار(ات) غير النشطة {lanes} لا يمكن أن تكون أيضاً في مسارات الاحتجاز.",
  "inductconfig.inactivePalletOverlap": "المسار(ات) غير النشطة {lanes} لا يمكن أن تكون أيضاً في مسارات البالتات.",
  "inductconfig.palletLanes": "مسارات البالتات",
  "inductconfig.priorityLaneCount": "عدد المسارات ذات الأولوية",
  "inductconfig.priorityLaneCountHint": "أدخل عدد المسارات ذات الأولوية (مثال: 25)",
  "inductconfig.beltNoContainerTypes": "حزام واحد أو أكثر لا يحتوي على أنواع حاويات محددة. حدد نوع حاوية واحد على الأقل لكل حزام.",
  "inductconfig.beltNoCubeTypes": "حزام واحد أو أكثر لا يحتوي على أنواع مكعبات محددة. حدد نوع مكعب واحد على الأقل لكل حزام.",
  "inductconfig.noActiveBelts": "لا توجد أحزمة إدخال نشطة مكوّنة. يجب أن يكون هناك حزام واحد نشط على الأقل لمعالجة الطرود.",
  "inductconfig.containerTypeNotCovered": "نوع حاوية واحد أو أكثر غير مخصص لأي حزام نشط. يجب تغطية جميع أنواع الحاويات بحزام نشط واحد على الأقل.",
  "inductconfig.cubeTypeNotCovered": "نوع مكعب واحد أو أكثر غير مخصص لأي حزام نشط. يجب تغطية جميع أنواع المكعبات بحزام نشط واحد على الأقل.",
  "inductconfig.invalidLaneEntered": "تم إدخال مسار غير صالح. يرجى إدخال معرف مسار صالح.",
  "inductconfig.selectCycleBeforeUpload": "يرجى تحديد دورة قبل تنفيذ التحميل.",
  "inductconfig.invalidCycleInCsv": "دورة غير صالحة أو مفقودة في ملف CSV. يرجى إدخال دورة صالحة."
}
